"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadGateway = void 0;
const ApiException_1 = require("./ApiException");
class BadGateway extends ApiException_1.ApiException {
    constructor(message = 'Bad Gateway', data) {
        super(message, data);
    }
}
exports.BadGateway = BadGateway;
